module.exports = __webpack_public_path__ + "resources/img/img_vehicle_process.5503c1f80781a435aa4c3008c2334ef3.png";